<div class="privacy">

  <div class="title">
    <app-text size="xl" weight="l">會員隱私權條款</app-text>
  </div>

  <div class="content">
    <app-text size="reportItem" weight="s">歡迎使用國泰健康管理股份有限公司（以下簡稱本公司）所提供之健檢預約及相關線上服務。</app-text>
    <app-text size="reportItem" weight="s">
      本條款旨在說明本公司如何蒐集、處理及利用您的個人資料，以及您在使用本服務時的權利義務。您於會員註冊並勾選同意後，即視為已充分理解並接受本條款內容。
    </app-text>
    <app-text class="subtitle" size="legal" color="gray-900" weight="m">
      本網站上述蒐集資料之運用政策
    </app-text>
    <app-text size="reportItem" weight="s">
      本網站所蒐集的個人資料，將依其蒐集時所闡述之特定目的使用，線上申請服務中所涉及的個人資訊將會被轉交給負責該項服務的相關單位，以便與您聯繫。針對各類線上活動，該個人資料將會視蒐集目的做為答覆問題及抽獎結果的通知、商業及市場的分析…等之用。個人資料之使用目的、利用對象、時間等資訊請參考活動網頁之內容，本網站不會將其做為超出蒐集之特定目的以外的用途。
    </app-text>
    <app-text class="subtitle" size="legal" color="gray-900" weight="m">
      Cookies 的運用與政策
    </app-text>
    <app-text size="reportItem" weight="s">
      Cookies 是伺服端為了區別使用者的不同喜好，經由瀏覽器寫入使用者硬碟的一些簡短資訊。您可以在瀏覽器設定中選擇修改您瀏覽器對 Cookies 的接受程度，包括接受所有 cookies、設定 cookies
      時得到通知、拒絕所有 cookies 等三種。如果您選擇拒絕所有的 cookies，您就可能無法使用部分個人化服務，或是參與部分的活動。為了提供您更好、更個人化的服務，以及方便您參與個人化的互動活動。Cookies
      在您註冊或登入時建立，並在您登出時修改。另外，為了統計瀏覽人數及分析瀏覽模式，以瞭解網頁瀏覽的情況，做為本網站改善服務的參考，本網站會在本政策原則下，在您瀏覽器中寫入並讀取 Cookies。
    </app-text>
    <app-text class="subtitle" size="legal" color="gray-900" weight="m">
      本網站與第三者共用個人資料之政策
    </app-text>
    <app-text size="reportItem" weight="s">
      本網站絕對不會任意出售、交換、出租或以其他變相之方式，將您的個人資料揭露與其他團體或個人。惟有下列三種情形，本網站會與第三人共用您的個人資料：
    </app-text>
    <ol class="list text">
      <li><app-text size="reportItem" weight="s">經過您的事前同意或授權允許時。</app-text></li>
      <li><app-text size="reportItem" weight="s">司法單位或其他主管機關經合法正式的程序要求時。</app-text></li>
      <li><app-text size="reportItem"
          weight="s">為了提供您其他服務或優惠權益，需要與提供該服務或優惠之第三人共用您的資料時，本網站會在活動時提供充分說明並告知，您可以自由選擇是否接受這項服務或優惠。</app-text></li>
    </ol>
    <app-text class="subtitle" size="legal" color="gray-900" weight="m">
      本網站傳送商業資訊或電子郵件之政策
    </app-text>
    <app-text size="reportItem" weight="s">
      為了增加整體服務內容，本網站所傳送的內容將包含非本行的服務或其他優惠權益訊息，我們將會在活動時提供充分的說明，您可以自由選擇是否接受這項特定服務或活動，若您選擇接受本項服務，本網站保證不會將您在本網站或本行所登錄的任何資料轉送給第三人。本網站將在事前或註冊登錄取得您的同意後，傳送商業性資料或電子郵件給您。本網站除了在該資料或電子郵件上註明是由我們發送，也會在該資料或電子郵件上提供您能隨時停止接收這些資料或電子郵件的方法、說明或功能連結。
    </app-text>
  </div>

  <hr>
  <div class="content">
    <app-text  size="xl" weight="m">一、個人資料之蒐集</app-text>
    <ol class="list">
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">蒐集項目</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">基本識別資料：姓名、性別、出生年月日、國籍、身分證字號、護照號碼、聯絡方式（電話、電子郵件、地址等）。</app-text></li>
          <li><app-text size="reportItem" weight="s">特徵資料：年齡、抽菸與飲酒習慣等生活習慣。</app-text></li>
          <li><app-text size="reportItem" weight="s">健康與其他資料：個人及家族病史、運動習慣、營養狀況、飲食情況等。</app-text></li>
          <li><app-text size="reportItem" weight="s">系統使用紀錄：IP位址、瀏覽行為、Cookies、裝置資訊、使用時長、點擊紀錄等。</app-text></li>
          <li><app-text size="reportItem" weight="s">互動紀錄：透過網站、APP、AI Chatbot 與本公司互動的內容。</app-text></li>
          <li><app-text size="reportItem" weight="s">其他本公司及合作之健康檢查中心、診所、體適能中心在執行業務範圍內所需蒐集之個人資料。</app-text></li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">蒐集方式</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">會員註冊、健檢預約或使用服務時填寫與提供。</app-text></li>
          <li><app-text size="reportItem" weight="s">參與活動、問卷、行銷活動時提供。</app-text></li>
          <li><app-text size="reportItem" weight="s">使用網站、APP 或 AI Chatbot 過程中系統自動記錄。</app-text></li>
          <li><app-text size="reportItem" weight="s">與本公司合作診所、關係企業或第三方合作服務時取得。</app-text></li>
        </ul>
      </li>
    </ol>
  </div>
  <div class="content">
    <app-text size="reportItem" weight="s">
      您已明確知悉並同意，本公司得基於特定目的，蒐集、處理及利用屬於個人資料保護法所定敏感個人資料之健康資訊及生活習慣資訊，並採取必要安全措施予以保護。
    </app-text>
  </div>
  <hr>
  <div class="content">
    <app-text  size="xl" weight="m">二、個人資料之利用</app-text>
    <ol class="list">
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">使用目的</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">提供健檢預約、會員管理、客服與售後服務。</app-text></li>
          <li><app-text size="reportItem" weight="s">依據個人需求提供客製化健康建議與健檢方案推薦。</app-text></li>
          <li><app-text size="reportItem" weight="s">進行行銷活動、優惠通知、滿意度調查。</app-text></li>
          <li><app-text size="reportItem" weight="s">系統安全維護、異常追蹤與詐騙防制。</app-text></li>
          <li><app-text size="reportItem" weight="s">進行數據分析、AI 模型訓練與服務優化（資料將去識別化處理）。</app-text></li>
          <li><app-text size="reportItem" weight="s">依主管機關或法律規定辦理相關作業。</app-text></li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">使用期間</app-text>
        <ul>
          <li><app-text size="reportItem"
              weight="s">自您提供資料起至您依規定請求刪除或停止使用為止，或依法令規定之保存期間。於特定目的消失或保存期間屆滿後，本公司將依內部程序安全刪除或去識別化處理您的個人資料，惟依法需保存者，不在此限。</app-text>
          </li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">使用地區</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">中華民國（台灣地區）及本公司相關服務所在地。</app-text></li>
        </ul>
      </li>
    </ol>
  </div>
  <hr>
  <div class="content">
    <app-text size="xl" weight="m">三、資料共享與第三方提供</app-text>
    <ol class="list">
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">合作單位</app-text>
        <ul>
          <li>
            <app-text size="reportItem" weight="s">您的資料可能提供予：</app-text>
            <ul>
              <li><app-text size="reportItem" weight="s">提供健檢預約、會員管理、客服與售後服務。</app-text></li>
              <li><app-text size="reportItem" weight="s">依據個人需求提供客製化健康建議與健檢方案推薦。</app-text></li>
              <li><app-text size="reportItem" weight="s">進行行銷活動、優惠通知、滿意度調查。</app-text></li>
              <li><app-text size="reportItem" weight="s">系統安全維護、異常追蹤與詐騙防制。</app-text></li>
              <li><app-text size="reportItem" weight="s">進行數據分析、AI 模型訓練與服務優化（資料將去識別化處理）。</app-text></li>
              <li><app-text size="reportItem" weight="s">依主管機關或法律規定辦理相關作業。</app-text></li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">行銷用途</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">經您同意，本公司得使用您的資料進行行銷推廣，並透過電子郵件、簡訊、電話、LINE 官方帳號訊息等方式通知您優惠與活動資訊。</app-text>
          </li>
          <li><app-text size="reportItem" weight="s">您可隨時依指示取消接收。</app-text></li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">AI Chatbot 與智慧服務</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">AI Chatbot
              僅提供健康管理與營養參考資訊，非醫療診斷或治療，不能取代專業醫師建議，本公司對因依賴該建議而造成之直接或間接損害，不承擔法律責任。</app-text></li>
          <li><app-text size="reportItem" weight="s">提供之資料與互動紀錄，將在去識別化後用於AI模型訓練、系統優化與新功能開發。</app-text></li>
        </ul>
      </li>
    </ol>
  </div>
  <hr>
  <div class="content">
    <app-text class="heading" size="xl" weight="m">四、您的權利</app-text>
    <app-text size="reportItem" weight="s">依個人資料保護法第3條，您可行使以下權利：</app-text>
    <ol class="list text">
      <li><app-text size="reportItem" weight="s">查詢或請求閱覽。</app-text></li>
      <li><app-text size="reportItem" weight="s">請求製給複製本。</app-text></li>
      <li><app-text size="reportItem" weight="s">請求補充或更正。</app-text></li>
      <li><app-text size="reportItem" weight="s">請求停止蒐集、處理或利用。</app-text></li>
      <li><app-text size="reportItem" weight="s">請求刪除。</app-text></li>
    </ol>
    <app-text size="reportItem" weight="s">申請方式：請透過本公司客服或網站留言系統提出申請。</app-text>
  </div>
  <hr>
  <div class="content">
    <app-text  size="xl" weight="m">五、資料安全</app-text>
    <ol class="list">
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">自我保護措施</app-text>
        <ul>
          <li><app-text size="reportItem" weight="s">本網站使用SSL（Secure Socket
              Layer）加密技術以保護您所提供的資訊，以免在傳輸時被其他第三人加以截取。本公司努力提供安全的資訊環境，建立防火牆、加密技術、使用者辨識系統（例如密碼及個人帳號）及存取控制機制，以控制個人資料之存取。請妥善保管您的任何個人資料、CA憑證或密碼，不要將任何個人資料，尤其是密碼提供給任何人或其他機構。在您使用完本網站所提供的各項服務功能後，務必記得登出，若您是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料或信件。
            </app-text></li>
        </ul>
      </li>
      <li>
        <app-text class="subtitle" size="legal" color="gray-900"
          weight="m">除依法令規定或取得您額外同意外，本公司不會將您的可識別個人資料出售、出租或以其他不當方式提供予第三方。</app-text>
      </li>
    </ol>
  </div>
  <hr>
  <div class="content">
    <app-text  size="xl" weight="m">六、條款更新</app-text>
    <ul class="list list--disc">
      <li>
        <app-text class="subtitle" size="legal" color="gray-900" weight="m">消費者聯絡資訊</app-text>
      </li>
    </ul>
    <app-text size="reportItem" weight="s">
      本公司將會視需要隨時修改本網站所提供的隱私權保護聲明，以落實保障您的隱私權。建議您於再次來訪時，可重新瞭解我們新的隱私權政策及其改變。條款如有重大變更，本公司將透過網站公告或以您提供之聯絡方式通知您，並於取得您同意後再行適用涉及個資新利用目的之部分。
    </app-text>
  </div>
  <hr>
  <div class="content">
    <app-text class="heading" size="xl" weight="m">七、通知型訊息說明條款</app-text>
    <app-text size="reportItem" weight="s">
      國泰健康管理股份有限公司將以通知型訊息傳送重要訊息給您。即使未加入國泰健康管理股份有限公司好友，您仍可接收到通知型訊息。本公司/本服務傳送之通知型訊息以對您有效且重要的訊息為限，以廣告或其他目的的訊息皆不會被傳送。滿足以下三個條件者，將可收到通知型訊息。
    </app-text>
    <ol class="list text">
      <li><app-text size="reportItem" weight="s">LINE 帳號設定的電話號碼與本公司/本服務所傳來的電話號碼比對相符</app-text></li>
      <li><app-text size="reportItem" weight="s">該 LINE 帳號已在 LINE APP 設定中，同意接收通知型訊息</app-text></li>
      <li><app-text size="reportItem" weight="s">LINE 帳號未封鎖傳送訊息之 LINE 官方帳號。</app-text></li>
    </ol>
  </div>
  <div class="content">
    <app-text size="reportItem" weight="s">欲變更通知型訊息的設定，操作如下：點選「主頁」＞「設定」</app-text>
    <ol class="list text">
      <li><app-text size="reportItem" weight="s">點選「隱私設定」</app-text></li>
      <li><app-text size="reportItem" weight="s">點選「提供使用資料」</app-text></li>
      <li><app-text size="reportItem" weight="s">點選「LINE通知型訊息」</app-text></li>
      <li><app-text size="reportItem" weight="s">開關「接收LINE通知型訊息」</app-text></li>
      <li><app-text size="reportItem" weight="s">關閉「接收通知型訊息」後，將不會接收到來自任何企業官方帳號或認證官方帳號的通知型訊息。</app-text></li>
    </ol>
  </div>
</div>